import failStatusIcon from '@p2p/assets/img/fail_status_icon.png';
import { Button, CopyIconButton, MainContainer } from '@p2p/components';
import { useParams } from 'react-router-dom';

import styles from './FailTransfer.module.scss';

type FailTransferProps = {
  url: string;
};

export const FailTransfer = (props: FailTransferProps) => {
  const { url } = props;
  const { id } = useParams();
  const handleNavigate = () => {
    window.location.href = url;
  };
  return (
    <MainContainer>
      <div className={styles.wrapper}>
        <center>
          <img className={styles.statusImg} src={failStatusIcon} alt="ok status icon" />
          <h1>Извините, платеж не был совершен</h1>
        </center>
        <div className={styles.block}>
          <span>Номер заявки</span>
          <p>
            {id}
            <CopyIconButton text={id || ''} />
          </p>
        </div>
        <Button variant="v1" onClick={handleNavigate} className={styles.btn__back} fullWidth>
          Вернуться на сайт партнера
        </Button>
      </div>
    </MainContainer>
  );
};
